export default __webpack_public_path__ + "static/media/sgolf.1440db66.png";